export default "__VITE_ASSET__973a9e2c__"